import React, { useContext, useState } from "react";
import {
  MdKeyboardDoubleArrowRight,
  MdKeyboardDoubleArrowLeft,
} from "react-icons/md";
import { AuthContext } from "../AuthContextComponent";
import useUserLogin from "../../hooks/UserLoginhook";

interface PaginationProps {
  currentPage: number;
  currentData?: string[][];
  totalPages: number;
  onPageChange: (page: number) => void;
  isReport?: boolean;
  isPendingRequestPage?: boolean;
}

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  isReport,
  isPendingRequestPage,
}: PaginationProps) => {
  const getPaginationRange = () => {
    const startPage = Math.max(1, currentPage - 1);
    const endPage = Math.min(totalPages, startPage + 2);
    const pages = [];

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  };

  const paginationPages = getPaginationRange();
  const { userInfo } = useContext(AuthContext);
  const { customColor } = useUserLogin();
  const [isLeftHovered, setIsLeftHovered] = useState(false);
  const [isRightHovered, setIsRightHovered] = useState(false);

  return (
    <div
      className={`flex justify-end h-full pr-6 w-full py-4 font-sans text-custom-micro ${
        isReport ? `pr-5` : ``
      } ${isPendingRequestPage ? `pr-[68px]` : ``}`}
    >
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 mx-1"
      >
        <MdKeyboardDoubleArrowLeft
          className={`hover:text-custom-default-hover ${
            userInfo?.theme === "DARK" ? `text-white` : `text-gray-500`
          } text-lg hover:scale-110`}
          style={{
            color: isLeftHovered ? customColor : "",
          }}
          onMouseEnter={() => setIsLeftHovered(true)}
          onMouseLeave={() => setIsLeftHovered(false)}
        />
      </button>

      {paginationPages.map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          style={{ backgroundColor: page === currentPage ? customColor : "" }}
          className={`px-3 bg-custom-default mx-1 rounded hover:scale-110 transition-all duration-300 ${
            page === currentPage ? "text-white " : "bg-gray-200 text-gray-600"
          }`}
        >
          {page}
        </button>
      ))}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 mx-1"
      >
        <MdKeyboardDoubleArrowRight
          className={` hover:text-custom-default-hover ${
            userInfo?.theme === "DARK" ? `text-white` : `text-gray-500`
          }  text-lg hover:scale-110`}
          style={{
            color: isRightHovered ? customColor : "",
          }}
          onMouseEnter={() => setIsRightHovered(true)}
          onMouseLeave={() => setIsRightHovered(false)}
        />
      </button>
    </div>
  );
};

export default Pagination;
